<div class="section-title-container">
    <div class="section-title-container__content">
      <div class="section-title-container__content__title">{{ title | translate }}</div>
      <div class="divider"></div>
      <div class="section-title-container__content__desc">{{ desc | translate }}</div>
    </div>
</div>
  